// extracted by mini-css-extract-plugin
export default {"fields":"AccountSetupForm_fields__Ps712","divider":"AccountSetupForm_divider__rjQcH"};